function trackOverflows(track) {
    return track.scrollWidth > track.clientWidth + 4;
}

function bindOverflowArrows(track, arrows, prev, next, amount) {
    if (!track || !arrows) {
        return;
    }
    const update = () => {
        arrows.hidden = !trackOverflows(track);
    };
    prev?.addEventListener('click', () => {
        track.scrollBy({ left: -amount(), behavior: 'smooth' });
    });
    next?.addEventListener('click', () => {
        track.scrollBy({ left: amount(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
}

const boundPillTracks = new WeakSet();

function updatePillFade(track) {
    const overflows = trackOverflows(track);
    const atStart = track.scrollLeft <= 4;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    track.classList.toggle('is-fade-left', overflows && !atStart);
    track.classList.toggle('is-fade-right', overflows && !atEnd);
}

export function bindPillsOverflow() {
    document.querySelectorAll('.taohs-pills-arrows').forEach((arrows) => {
        arrows.hidden = true;
    });
    document.querySelectorAll('.taohs-pills').forEach((track) => {
        if (!boundPillTracks.has(track)) {
            boundPillTracks.add(track);
            track.addEventListener('scroll', () => updatePillFade(track), { passive: true });
            window.addEventListener('resize', () => updatePillFade(track));
        }
        updatePillFade(track);
    });
}

export default function carousel() {
    document.querySelectorAll('.taohs-rail, .taohs-carousel').forEach((root) => {
        const track = root.querySelector('.js-carousel');
        if (!track) {
            return;
        }
        const prev = root.querySelector('.js-carousel-prev');
        const next = root.querySelector('.js-carousel-next');
        const arrows = root.querySelector('.taohs-rail-arrows, .taohs-motion-feature-arrows');
        const scrollBy = () => {
            if (root.classList.contains('taohs-motion-feature')) {
                return track.clientWidth;
            }
            return Math.max(track.clientWidth * 0.8, 265);
        };

        bindOverflowArrows(track, arrows, prev, next, scrollBy);
        if (!arrows) {
            prev?.addEventListener('click', () => {
                track.scrollBy({ left: -scrollBy(), behavior: 'smooth' });
            });
            next?.addEventListener('click', () => {
                track.scrollBy({ left: scrollBy(), behavior: 'smooth' });
            });
        }
    });

    document.querySelectorAll('.js-snap').forEach((row) => {
        const cards = [...row.querySelectorAll('.taohs-card')];
        if (cards.length < 2) {
            return;
        }
        if (!row.classList.contains('js-carousel')) {
            const wrap = row.closest('.taohs-card-row-wrap');
            const arrows = wrap?.querySelector('.taohs-row-arrows');
            const prev = wrap?.querySelector('.js-row-prev');
            const next = wrap?.querySelector('.js-row-next');
            bindOverflowArrows(row, arrows, prev, next, () => Math.max(row.clientWidth * 0.8, 265));
        }

        if (!row.classList.contains('taohs-card-row')) {
            return;
        }

        const dots = document.createElement('div');
        dots.className = 'taohs-dots';
        cards.forEach((_, i) => {
            const b = document.createElement('button');
            b.type = 'button';
            if (i === 0) {
                b.classList.add('is-active');
            }
            b.addEventListener('click', () => {
                cards[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
            });
            dots.appendChild(b);
        });
        row.after(dots);

        const setActive = () => {
            const rowRect = row.getBoundingClientRect();
            let best = 0;
            let bestVisible = -1;
            cards.forEach((card, idx) => {
                const r = card.getBoundingClientRect();
                const visible = Math.min(r.right, rowRect.right) - Math.max(r.left, rowRect.left);
                if (visible > bestVisible) {
                    bestVisible = visible;
                    best = idx;
                }
            });
            dots.querySelectorAll('button').forEach((b, idx) => {
                b.classList.toggle('is-active', idx === best);
            });
        };

        row.addEventListener('scroll', setActive, {passive: true});
        window.addEventListener('resize', setActive);
    });

    bindPillsOverflow();
}
